import {HttpService} from './HttpService';

class AuthenticationService {
    getTransferInfo(nonce) {
        return new Promise((resolve, reject) => {
            try {
                const svc = HttpService.createWithoutAuthorization();
                svc.callApiAnonymously('GET', `/login/oauth/${nonce}`)
                    .then(result => resolve(result.data),
                        err => reject(err));
            } catch (error) {
                reject(error);
            }
        });
    }
    checkForAndInformParentOfTimeout = (targetOrigin) => {
        if (window.parent) {
            window.parent.postMessage("auth-timeout", targetOrigin);
        }
    };
}

const svc = new AuthenticationService();

export default svc;

